module.exports = __webpack_public_path__ + "static/media/plus_icon.f325663b.svg";